import React from 'react'
import styles from './styles.css'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import AdvancedSettings from '../AdvancedSettings'
import isAdmin from 'App/Decorators/isAdmin'
import Title from './Title'
import Signers from '../Signers'
import FeaSigners from '../FeaSigners'
import Actions from '../Actions'
import Viewers from '../Viewers'
import BioSigners from '../BioSigners'

@isAdmin
@withRouter
export default class Status extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    document: PropTypes.object,
    organization: PropTypes.object,
    admin: PropTypes.string,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  static fragment = gql`
    fragment documentViewStatus on Document {
      signers {
        name
        email
      }
      
      
      activities {
        action
        userEmail
        date
        ip
      }
      
      viewers {
        name
        email
      }
      documentStatus {
        status
      }
    }
  `

  state = {}

  render() {
    //console.log("Document Status: ", this.props.document.bioSigners)
    return (
      <div className={styles.container}>
        <Title
          document={this.props.document}
          params={this.props.params}
          url={this.props.url}
        />
        <AdvancedSettings
          document={this.props.document}
          organization={this.props.organization}
        />
        <Signers document={this.props.document} />
        
        {this.props.document.bioSigners ? (
          <BioSigners document={this.props.document} />
        ) : null}
        {this.props.document.feaSigners ? (
          <FeaSigners document={this.props.document} />
        ) : null}
        <Actions document={this.props.document} />
        <Viewers document={this.props.document} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Status/index.js